<template>
  <div class="space-y-2 relative">
    <WishlistButton
      :wished="wished"
      :product-id="selectedProduct.id"
      class="absolute top-0 right-0 z-10"
    />
    <a
      :href="`/${selectedProduct.slug}`"
      class="block"
    >
      <div class="space-y-2 pt-12 relative">
        <div class="absolute top-0 left-0">
          <ProductBadge
            :key="selectedProduct.id"
            :product="selectedProduct"
            :shop="shop"
          />
        </div>
        <ProductImage
          :key="selectedProduct.id"
          :product="selectedProduct"
        />
        <p class="text-base line-clamp-2">
          {{ selectedProduct.name }}
        </p>
        <div class="flex flex-col sm:flex-row sm:justify-between">
          <ProductEstimatedTime
            :key="selectedProduct.id"
            :product="selectedProduct"
            :shop="shop"
          />
          <ProductReviewStats :product="selectedProduct" />
        </div>
        <ProductPrice :product="selectedProduct" />
      </div>
    </a>
    <ProductVariation
      :product="product"
      :selected-product="selectedProduct"
      @select="selectedProduct = $event"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ProductImage from './ProductImage.vue';
import ProductEstimatedTime from './ProductEstimatedTime.vue';
import ProductReviewStats from './ProductReviewStats.vue';
import ProductPrice from './ProductPrice.vue';
import ProductVariation from './ProductVariation.vue';
import ProductBadge from './ProductBadge.vue';
import WishlistButton from '../../myAccount/wishlist/components/WishlistButton.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  shop: {
    type: Object,
    required: true,
  },
  wished: {
    type: Boolean,
    default: null,
  },
});
const selectedProduct = ref(props.product);
</script>
